/**
 * @module ol/layer/Property
 */
/**
 * @enum {string}
 */
export default {
    OPACITY: 'opacity',
    VISIBLE: 'visible',
    EXTENT: 'extent',
    Z_INDEX: 'zIndex',
    MAX_RESOLUTION: 'maxResolution',
    MIN_RESOLUTION: 'minResolution',
    MAX_ZOOM: 'maxZoom',
    MIN_ZOOM: 'minZoom',
    SOURCE: 'source',
    MAP: 'map',
};
//# sourceMappingURL=Property.js.map


//////////////////
// WEBPACK FOOTER
// ./~/ol/layer/Property.js
// module id = 272
// module chunks = 8